import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BootstrapIconsModule } from 'ng-bootstrap-icons';
import { Calendar } from 'ng-bootstrap-icons/icons';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    BootstrapIconsModule.pick({Calendar})
  ],
  exports: [BootstrapIconsModule]
})
export class IconsModule { }
